import styled from 'styled-components'

export const ContentWrapper = styled.div`
  margin-top: 10px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin: 0 15px;
  }

  .spacing-bottom {
    margin-bottom: 15px;

    &-large {
      margin-bottom: 20px;

      @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
        margin-bottom: 30px;
      }
    }
  }
`
